import {ajax} from 'rxjs/ajax';
import {API_URL} from '../config/entrypoint';

export function addRelocationFileAPI(authToken: string, formData: FormData) {
    return ajax({
        url: `${API_URL}/api/relocation_files`,
        method: 'POST',
        body: formData,
        headers: {
            Authorization: 'Bearer ' + authToken,
        },
    });
}
